import React from 'react';
import { theme } from 'antd';
import { useTranslation } from 'react-i18next';

import PlusIcon from '@/comp/common/icons/PlusIcon';
import { EPButton } from '@/components';

const { useToken } = theme;

interface AddStationButtonRowProps {
  onAddStation: () => void;
  disabled: boolean;
  isReady: boolean;
}

const AddStationButtonRow: React.FC<AddStationButtonRowProps> = ({ onAddStation, disabled, isReady }) => {
  const { token } = useToken();
  const { t } = useTranslation();

  return (
    <EPButton
      disabled={disabled}
      onClick={onAddStation}
      type="primary"
      ghost
      icon={<PlusIcon color={disabled ? token.colorIcon : token.colorPrimary} />}
      showSkeleton={!isReady}
    >
      {t('addStation')}
    </EPButton>
  );
};

export default AddStationButtonRow;
